import { ApiClient } from "../config/axiosConfig";
import { IDocument, IDocumentQuery, IUploadDocument } from "../models/Document";
import { IPaginatedResponse } from "../models/Pagination";

export const documentService = {
  getDocument: async (query: IDocumentQuery) => {
    const response = ApiClient.GET<IPaginatedResponse<IDocument>>(
      "/documents",
      query,
    );
    return response;
  },
  downloadDocument: async (id: number) => {
    const response = ApiClient.GET<string>(`/documents/${id}/download`);
    return response;
  },
  viewDocument: async (id: number) => {
    const response = ApiClient.GET<string>(`/documents/${id}/view`);
    return response;
  },

  uploadDocument: async (data: IUploadDocument | undefined) => {
    const response = ApiClient.POST<IDocument>(`/documents`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  },
  deleteDocument: async (id: number) => {
    const response = ApiClient.DELETE(`/documents/${id}`);
    return response;
  },
};
